import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-wall-nav',
  templateUrl: './wall-nav.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WallNavComponent {

  queryKeysToClearOnMapClick = {
    pageSize: null,
    pageIndex: null
  };

  queryKeysToClearOnVisualizationClick = {
    pageSize: null,
    pageIndex: null
  };

  queryKeysToClearOnChartClick = {
    pageSize: null,
    pageIndex: null,
    orderBy: null
  };

  queryKeysToClearOnListClick = {
    layers: null,
    orderBy: null,
    selectedPeopleIds: null,
    selectedPersonId: null,
    personMarkerLngLat: null
  };

}
